




























import { Component, Prop, Vue } from 'vue-property-decorator';  
import ProdutoI from "@/Interfaces/Produto"
import BotaoAdicionar from '@/components/Loja/Produto/BotaoAdicionar.vue'

@Component({
  components: {
      BotaoAdicionar
  },
})
export default class Produto extends Vue { 
    @Prop() produto!: ProdutoI  
}
